import { render } from "./GridMetaCorrigida.vue?vue&type=template&id=22569648"
import script from "./GridMetaCorrigida.vue?vue&type=script&lang=js"
export * from "./GridMetaCorrigida.vue?vue&type=script&lang=js"

import "./GridMetaCorrigida.vue?vue&type=style&index=0&id=22569648&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__